import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from "styled-components";
export var ExtendedSvg = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fill: currentColor;\n"])));